module.exports = __webpack_public_path__ + "static/media/icon_specs-o2.12936dea.svg";